import React from "react";
import { Team } from "../utils/types";
import TeamScore from "./TeamScore";

export default function TeamsSummary({ data }: { data: Team[] }) {
  return (
    <article className="teams-summary-container">
      <h4>Total Score</h4>
      <section className="teams-data">
        {data.map((team) => (
          <TeamScore key={team.id} team={team} />
        ))}
        {!data.length && <h3 className="empty-message">No Teams To Show </h3>}
      </section>
    </article>
  );
}
